module.exports = __webpack_public_path__ + "img/clock.7761c0d7.svg";